import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DeviceModelDetailsComponent } from './device-model-details.component';

const routes: Routes = [
  {
    path: 'device-model-details',
    component: DeviceModelDetailsComponent,
  },
  {
    path: 'device-model-details/:modelId',
    component: DeviceModelDetailsComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DeviceModelDetailsRoutingModule {}
